module.exports = __webpack_public_path__ + "img/cupcake.14e40ec2.png";